module.exports = "/images/logo.svg?6dbb88dc3def5ae45e39f22b11a01542";